module.exports = __webpack_public_path__ + "img/user-group2_zh.ac5cb23a.png";